export enum RebuildRouteTypeEnum {
  Default = "Default",
  RefreshCache = "RefreshCache",
  SkipCacheWithoutUpdate = "SkipCacheWithoutUpdate",
  ProviderOptimization = "ProviderOptimization",
  BestFit = "BestFit",
  OptimizeStationOrderOsrmFirst = "OptimizeStationOrderOsrmFirst",
  KeepOrder = "KeepOrder",
  EndpointsLocked = "EndpointsLocked",
}
